export const Bio = {
  name: "Madhura Ingole",
  roles: [
    "Programmer",
    "Developer",
    "UI/UX Designer",   
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges.",
  github: "https://github.com/madhura-ingole",
  resume:
    "https://drive.google.com/file/d/1ogR-tL_FIQe3Ag-mk6NP-77YnVoTpig4/view",
  linkedin: "https://www.linkedin.com/in/madhura-ingole/",
  twitter: "https://twitter.com/madhura_ingole",
  insta: "https://www.instagram.com/madhura_ingole/",
  facebook: "https://www.facebook.com/profile.php?id=100082135865015",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Motoko",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/motoko.jpg?raw=true",
      },
    ],
  },
  {
    title: "UI/UX Designing",
    skills: [
      {
        name: "Figma",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/figma.png?raw=true",
      },
      {
        name: "Adobe XD",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/image.png?raw=true",
      },
      {
        name: "Adobe After Effects",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/adobe.png?raw=true",
      },
      {
        name: "Behance",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/behance.png?raw=true",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://raw.githubusercontent.com/madhura-ingole/portfolio-website-assets/c4a0888f64eda8de7811a83d9f1232c88dc82e3e/postman.svg",
      },
      {
        name: "Insomnia",
        image:
          "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/insomnia.png?raw=true",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/VEDC%20BIRD%20(2).png?raw=truehttps://github.com/madhura-ingole/portfolio-website-assets/blob/main/EDClogonewwhite%20(1).png?raw=true",
    role: "Multimedia Secratary",
    company: "Entreprenurship Development Club, VIT Pune",
    date: "2022 - 2023",
    desc: "Facilitated seamless coordination and execution, leveraging multimedia tools to enhance college community engagement.",
    skills: [
      "Multimedia Proficiency",
      "Creativity",
      "Leadership",
      "Website Design"
    ],
  },
  {
    id: 0,
    img: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/csi.jpeg?raw=true",
    role: "Coordinator",
    company: "CSI, VIT Pune",
    date: "2022-2023",
    desc: "Efficiently coordinated diverse activities, including tech-related tasks.",
    skills: [
      "Organization",
      "Communication",
      "Time Management",
      "Collaboration"
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/vit.jpg?raw=true",
    school: "Vishwakarma Institute of Technology, Pune",
    date: "Dec 2021 - Present",
    grade: "8.34 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Electronics and Telecommunication Engineering where I have taken courses like Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Web Technologies and Computer Networks. I have worked on various projects as a part of these courses.",
    degree: "Bachelor of Technology - BTech, Electronics and Telecommunication Engineering ",
  },
  {
    id: 1,
    img: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/stpaulcollege-logo.png?raw=true",
    school: "St. Paul Jr College, Nagpur",
    date: "June 2019 - June 2021",
    grade: "95.50%",
    desc: "I completed 12th grade (high school), where I studied Science with Computer Science.",
    degree: "HSC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/krishak.jpg?raw=true",
    school: "Krishak English School, Arvi",
    date: "June 2009 - June 2019",
    grade: "93.60%",
    desc: "I completed my education till 10th grade, where I studied and explored various courses.",
    degree: "SSC(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "Madhura's Blog",
    date: "2023-2024",
    description:
      "Designed for tutorial videos and content to engage a diverse audience.",
    image: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/Screenshot%202024-03-08%20014251.png?raw=true",
    tags: [
      "HTML",
      "Tailwind",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/madhura-ingole/mern-blog",
    webapp: "https://madhuras-blog.onrender.com/",
  },
  {
    id: 11,
    title: "Keeper Notes",
    date: "2022-2023",
    description:
      "A React-based notes application allowing users to add and delete notes.",
    image: "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/Keeper%20notes.png?raw=true",
    tags:  ["React Js", "Frontend", "HTML", "CSS", "Tailwind"],
    category: "web app",
    github: "https://github.com/madhura-ingole/my-notes",
    webapp: "https://madhura-ingole.github.io/my-notes/",
  },
  {
    id: 8,
    title: "Drum Kit",
    date: "2022-2023",
    description:
      "A drum kit web application enabling users to play sounds by pressing specific buttons.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/drum%20app.png?raw=true",
    tags: ["HTML", "CSS", "JavaScript", "Web Development", "Interactive"],
    category: "web app",
    github: "https://github.com/madhura-ingole/Drum-project",
    webapp: "https://madhura-ingole.github.io/Drum-project/",
  },
  {
    id: 0,
    title: "OpenD",
    date: "2023-2024",
    description:
      "Created a platform for minting NFTs with decentralized functionality and blockchain integration.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/Screenshot%202024-03-10%20163048.png?raw=true",
    tags: ["React Js", "Motoko", "Blockchain", "Decentralized", "NFTs"],
    category: "blockchain",
    github: "https://github.com/madhura-ingole/OpenD",
    webapp: "https://github.com/madhura-ingole/OpenD",

  },
  {
    id: 1,
    title: "DBank",
    date: "2022-2023",
    description:
      "A decentralized bank (DBank) application implemented on Ethereum blockchain, facilitating transactions, deposits, and withdrawals using smart contracts.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/dbank.png?raw=true",
    tags:  ["Ethereum", "Blockchain", "Smart Contracts", "Decentralized Finance", "Web3"],
    category: "blockchain",
    github: "https://github.com/madhura-ingole/dbank",
    webapp: "https://github.com/madhura-ingole/dbank",
  },
  {
    id: 2,
    title: "Design of e-commerce website",
    date: "2022-2023",
    description:
      "A case study showcasing the design process and user experience improvements for a shoes e-commerce website.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/shoes%20ecommerce.png?raw=true",
    tags:  ["UI Design", "UX Design", "E-commerce", "Website Design", "Case Study"],
    category: "design",
    github: "https://www.figma.com/file/2Lw28LDiTv8OzoLdLNKxrX/swano-shoes?type=design&node-id=0%3A1&mode=dev&t=56JvuTqGQeFxAOWV-1",
    webapp: "https://www.behance.net/gallery/165902279/Case-Study-Shoes-ecommerce-website",
  },
  {
    id: 3,
    title: "Parallax animation",
    date: "2022-2023",
    description:
      "A project showcasing a parallax swipe animation, offering an interactive and engaging user experience with dynamic visual effects.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/parallax.png?raw=true",
    tags: ["UI", "Parallax Effect", "Swipe Animation", "Interactive Design", "Adobe After Effects"],
    category: "design",
    github: "https://www.figma.com/file/EYZoYWvkEGLJvZXDXDVvf1/Episode-3%3A-Parallax-Scrolling?type=design&node-id=0%3A1&mode=dev&t=uXqziAhO4aq5FM13-1",
    webapp: "https://www.behance.net/gallery/151328055/Parralax-Swipe-Animation",
  },
  {
    id: 10,
    title: "3D Flip Credit Card UI animation",
    date: "2022-2023",
    description:
      "A 3D flip credit card UI animation project demonstrating an interactive user interface with realistic card flipping effects.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/slide%20card.png?raw=true",
    tags:  ["UI Animation", "3D Design", "Interactive UI", "User Experience", "Adobe After Effects"],
    category: "design",
    github: "https://www.figma.com/file/jQIkr4060qEvobCzUqjB57/Episode-4%3A-3D-Card-Flip-Animation?type=design&node-id=0%3A1&mode=dev&t=Bgc8nmWcmog8J9mC-1o",
    webapp: "https://www.behance.net/gallery/151374051/3D-Flip-Credit-Card-UI-Animation",
  },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: 
  //   description:
  //   image:
  //   category: 
  //   github: 
  //   webapp:
  // },
  {
    id: 5,
    title: "Movie ticket booking app design",
    date: "2021-2022",
    description:
      "A Movie Ticket Booking App design prototype showcasing an intuitive user interface for seamless booking experiences.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/movie%20ticket.png?raw=true",
    tags: ["UI Design", "Mobile App", "User Experience", "Figma"],
    category: "design",
    github: "https://www.figma.com/file/sAgV7lCqQUbwYAsgMQQwbM/movie-ticket?type=design&node-id=0%3A1&mode=dev&t=ry7VNJ4p8SP7frW3-1",
    webapp: "https://www.behance.net/gallery/151374139/Movie-Ticket-Booking-App",
  },
  {
    id: 6,
    title: "Watch e-commerce mobile app design",
    date: "2021-2022",
    description:
      "A Watch Shopping App design prototype featuring an elegant user interface for browsing and purchasing watches.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/watch%20page.png?raw=true",
    tags:  ["UI Design", "Mobile App", "Figma", "E-commerce"],
    category: "design",
    github: "https://www.figma.com/file/Z3nY4kKrP5qybPVrKoTKPX/Watch-e-commerce-mobile-app?type=design&node-id=0%3A1&mode=dev&t=6m5pGjJREc9hZz9t-1",
    webapp: "https://www.behance.net/gallery/149578813/Watch-Shopping-App",
  },
  {
    id: 7,
    title: "Sign up page design",
    date: "2021-2022",
    description:
      "A Sign-Up Page UI design prototype with a clean and user-friendly interface.",
    image:
      "https://github.com/madhura-ingole/portfolio-website-assets/blob/main/signup%20page.png?raw=true",
    tags: ["UI Design", "Web Design", "User Interface", "Figma"],
    category: "design",
    github: "https://www.figma.com/file/Rymt0PR0jJv1kphHsL7tzA/Untitled?type=design&node-id=0%3A1&mode=dev&t=PCqHTtzx5MlDrx53-1",
    webapp: "https://www.behance.net/gallery/148717353/Sign-Up-page",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
